import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.issue-key-field.label',
		defaultMessage: 'Key',
		description: 'Label for the key.',
	},
});
